import getWindow from "./auth-service-tools1160.js";

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

export { getComputedStyle as default };